module.exports = __webpack_public_path__ + "img/collection-engagementRingsHeart@2x.bd38f9a.webp";